/**
 * いま、この患者はどの状態か。確定済みHTMLの stateOf() と同一の判定順。
 * 中止は他のどの入力よりも優先して出す。
 */
export function stateOf(c) {
    if (c.clerk?.type === 'stop')
        return 'stop';
    if (c.adminDone)
        return 'done';
    if (c.admin)
        return 'admin';
    if (c.pharmDone)
        return 'made';
    if (c.pharm)
        return 'start';
    if (c.clerk)
        return c.clerk.type;
    return 'idle';
}
/**
 * 全体ボードの絞り込みキー。確定・変更はどちらも「調製待ち」にまとめる。
 * 調製完了は「調製開始済み」に含める（投与前で薬剤部を通過した案件として同じ括りで見る）。
 */
export const BOARD_FILTERS = ['idle', 'wait', 'start', 'made', 'admin', 'done', 'stop'];
export function boardFilterKey(c) {
    const st = stateOf(c);
    return st === 'confirm' || st === 'change' ? 'wait' : st;
}
export const CLERK_ACTION_LABEL = {
    confirm: '調製確定',
    change: '調製変更',
    stop: '調製中止',
};
/** 経過分。負の値は出さない（時刻ずれで「-1分」と出さないため）。 */
export function minutesSince(at, now) {
    return Math.max(0, Math.floor((now - at) / 60000));
}
/** 滞留アラート：確定から alertMin 分、調製に着手されていない案件。中止は対象外。 */
export function isStalled(c, now, alertMin) {
    if (!c.clerk || c.clerk.type === 'stop')
        return false;
    if (c.pharm)
        return false;
    return minutesSince(c.clerk.at, now) >= alertMin;
}
//# sourceMappingURL=state.js.map